'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = userInfo;

var _immutable = require('immutable');

var _TalonActionTypes = require('../actionTypes/TalonActionTypes');

var initialState = new _immutable.Map({
  talonValue: '{}'
});

function userInfo() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _TalonActionTypes.UPDATE_TALON_VALUE:
      return state.merge({ talonValue: payload });
    default:
      return state;
  }
}
module.exports = exports['default'];